import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { CustomerService } from '@proximus/ng-common';
import { OnDestroyHookDirective } from '../shared/hooks';

@Injectable()
export class AuOnlyGuard extends OnDestroyHookDirective implements CanActivate {
  constructor(private customerService: CustomerService) {
    super();
  }

  canActivate(): Observable<boolean> {
    return new Observable((observer) => {
      this.customerService.getCustomerAccount().subscribe((value) => {
        observer.next(
          value.getSelectedCustomer() && value.getSelectedCustomer().payer,
        );
        observer.complete();
      });
    });
  }
}
